import {AvailableVehicleUsageType} from '../../features/entities/category/enum/available-vehicle-usage-type.enum';
import {AvailableVehicleCategory} from '../../features/entities/category/enum/available-vehicle-category.enum';
import {VehicleCategory} from '../../features/entities/category/models/vehicle-category.model';

export function resolveVehicleUsageType(vehicleCategory: VehicleCategory): AvailableVehicleUsageType {
  switch (vehicleCategory.category) {
    case AvailableVehicleCategory.CAR:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.TRUCK:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.DELIVERY:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.TRAILERS:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.BUS:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.MOTORCYCLE:
      return AvailableVehicleUsageType.MILEAGE;
    case AvailableVehicleCategory.CONSTRUCTION_VEHICLE:
      return AvailableVehicleUsageType.MOTO_HOURS;
    case AvailableVehicleCategory.AGRICULTURAL_VEHICLE:
      return AvailableVehicleUsageType.MOTO_HOURS;
    case AvailableVehicleCategory.OTHER:
      return AvailableVehicleUsageType.BOTH;
    default:
      return AvailableVehicleUsageType.BOTH;
  }
}
